import { Column } from 'components/UIKit/Flex';

type QCSummaryToolbarProps = {
  title: string,
  subtitle: string
}

const styles = {
  title: {
    fontSize: '1.3rem',
    alignItems: 'center',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    margin: 0,
  },
  subtitle: {
    fontSize: '0.9rem',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
  },
};

export default function QCSummaryToolbar({
  subtitle,
  title,
}: QCSummaryToolbarProps): React.Element {
  return (
    <Column style={{ margin: 0, padding: '0px 0px 0px 0.5rem' }}>
      <h3 className="qc-summary-toolbar pdf-only" style={styles.title}>{ title }</h3>
      <span style={styles.subtitle}>{ subtitle }</span>
    </Column>
  );
}
